import { useCustomerIdGuard } from "../../../hooks/useCustomerIdGuard";
import { useGetNodes } from "../../../../pages/nodes/hooks/useGetNodes";

export const useGetNodesWithoutDeviceByCustomer = () => {
  const selectedCustomerId = useCustomerIdGuard();

  const { data, loading } = useGetNodes({
    customerId: selectedCustomerId,
    includeDevices: false,
  });

  return {
    data,
    loading,
  };
};
